import api from './apiService';
import { API_PATHS } from '../constants/portalApiPath';

const dashboardService = {
  getCounts: (data) => api.post(API_PATHS.DASHBOARD_COUNTS, data),
  getRevenueForDate: (data) => api.post(API_PATHS.DASHBOARD_REVENUE_DAY, data),
  getActivePatientsBySegment: (data) => api.post(API_PATHS.DASHBOARD_ACTIVE_PATIENTS, data),
  getUpcomingBirthdays: (data) => api.post(API_PATHS.DASHBOARD_BIRTHDAY, data),
  getOverviewGraph: (data) => api.post(API_PATHS.DASHBOARD_OVERVIEW_GRAPH, data),
  getMembersGraph: (data) => api.post(API_PATHS.DASHBOARD_MEMBERS_GRAPH, data),
  getInsights: (data) => api.post(API_PATHS.DASHBOARD_INSIGHTS, data),
  getPricingInsights: (data) => api.post(API_PATHS.ANALYTICS_PRICING, data),
  getUnpaidFees: (data) => api.post(API_PATHS.DASHBOARD_UNPAID_FEES, data),
  sendFeeReminders: () => api.post(API_PATHS.DASHBOARD_UNPAID_FEES, { sendReminder: true }),
  getRevenueByService: (data = {}) => api.post(API_PATHS.ANALYTICS_REVENUE_BY_SERVICE, data),
};

export default dashboardService;
